import SchoolIcon from '@mui/icons-material/School';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import BoltIcon from '@mui/icons-material/Bolt';
import GroupsIcon from '@mui/icons-material/Groups';
import ArticleIcon from '@mui/icons-material/Article';
import AssignmentIcon from '@mui/icons-material/Assignment';

export const SYSTEMS_REGISTRY = [
  {
    id: 'comunidad',
    icon: GroupsIcon,
    title: 'Muro de la Comunidad',
    label: 'Social',
    subtitle: 'Conecta con otros miembros',
    color: '#1877F2',
    bgColor: '#E7F3FF',
    isInternal: true,
    url: "/comunidad"
  },
  {
    id: 'blog',
    icon: ArticleIcon,
    title: 'Blog HitPoly',
    label: 'Contenido', 
    subtitle: 'Artículos, recursos y noticias',
    color: '#B51AD8',
    bgColor: '#F8EEFC',
    url: "https://blog.hitpoly.com/",
    isExternal: true,
    injectId: true
  },
  {
    id: 'academia',
    icon: SchoolIcon,
    title: 'Academia HitPoly',
    label: 'Módulos',
    subtitle: 'Carreras más demandadas',
    color: '#6C4DE2',
    bgColor: '#F4F7FE',
    url: "https://academy.hitpoly.com/",
    isExternal: true,
    injectId: true
  },
  {
    id: 'crm',
    icon: BusinessCenterIcon,
    title: 'Formark CRM',
    label: 'Gestión',
    subtitle: 'Segmenta todo tu recorrido',
    color: '#3B207F',
    bgColor: '#F0FFFF',
    url: "https://formarkcrm.hitpoly.com/",
    isExternal: true,
    injectId: true,
    isPro: true
  },
  {
    id: 'proyectos',
    icon: AssignmentIcon,
    title: 'Gestión de Proyectos',
    label: 'Nuevo',
    subtitle: 'Organiza tareas y actividades',
    color: '#FF6B35',
    bgColor: '#FFF5F0',
    url: "https://hitproyect.hitpoly.com/",
    isExternal: true,
    injectId: true
  },
  {
    id: 'bolsa',
    icon: BoltIcon,
    title: 'Bolsa de Profesionales',
    label: 'Contactar',
    subtitle: 'Talento global para tu empresa',
    color: '#3B207F',
    bgColor: '#F4FFF7',
    url: "https://bolsaprofesionales.hitpoly.com/",
    isExternal: true,
    injectId: true,
    isPro: true
  },
  {
    id: 'mensajes',
    icon: GroupsIcon,
    title: 'Mensajes y Negocios',
    label: 'Chat',
    subtitle: 'Comunícate con tu equipo',
    color: '#6C4DE2',
    bgColor: '#F7F4FF',
    url: "/mensajes",
    isInternal: true,
    // Todos los sistemas externos usan iframe-route-pattern
    // con routes.jsx, urlRecovery.js y historyGuard.js
  }
];

// ============================================
// CONFIGURACIÓN ESTÁNDAR PARA TODOS LOS IFRAMES
// Cada sistema debe implementar:
// 1. routes.jsx (mapa ruta -> componente)
// 2. urlRecovery.js (restaurar ?route= antes de React Router)
// 3. historyGuard.js (convertir pushState en replaceState)
// ============================================
export const IFRAME_ROUTE_PATTERN = 'iframe-route-pattern';